export default {
  common: {
    account: 'アカウント',
    agents: 'エージェント',
    all: 'すべて',
    available: '利用可能',
    cancel: 'キャンセル',
    cloud: 'クラウド',
    copy: 'コピー',
    current: '現在',
    delete: '削除',
    error: 'エラー',
    export: '書き出し',
    help: 'ヘルプ',
    home: 'ホーム',
    language: '言語',
    links: 'リンク',
    loading: '読み込み中',
    local: 'ローカル',
    login: 'ログイン',
    logout: 'ログアウト',
    metadata: 'メタデータ',
    more: '詳細',
    name: '名前',
    never: 'なし',
    none: 'なし',
    notes: 'メモ',
    ok: 'OK',
    open: '開く',
    password: 'パスワード',
    project: 'プロジェクト',
    projects: 'プロジェクト',
    publicLink: '公開リンク',
    register: '登録',
    remove: '削除',
    save: '保存',
    search: '検索',
    settings: '設定',
    subscribe: '購読',
    track: 'トラック',
    tracks: 'トラック',
    unknown: '不明',
    unknownArtist: '不明なアーティスト',
    upload: 'アップロード',
    username: 'ユーザー名'
  },
  time: {
    day: '日',
    days: '日',
    daysAgo: (ctx) => `${ctx.named('count')} 日前`,
    hoursAgo: (ctx) => `${ctx.named('count')} 時間前`,
    minutesAgo: (ctx) => `${ctx.named('count')} 分前`,
    rightNow: 'たった今',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes} 分 ${seconds} 秒`
      return `${seconds} 秒`
    }
  },
  topBar: {
    accountFallback: 'アカウント',
    storage: 'ストレージ',
    language: '言語'
  },
  commandPalette: {
    placeholder: 'トラックとプロジェクトを検索...',
    projects: 'プロジェクト',
    tracks: 'トラック',
    pages: 'ページ',
    noResults: '結果が見つかりません',
    quickLinks: 'クイックリンク',
    page: {
      home: 'ホーム',
      account: 'アカウント',
      agents: 'エージェント',
      links: 'リンク',
      settings: '設定',
      help: 'ヘルプ'
    }
  },
  explorer: {
    searchTitle: '検索',
    trackCount: (ctx) => `${ctx.named('count')} トラック`
  },
  emptyState: {
    hello: 'こんにちは',
    addTrack: 'トラックを追加',
    addTrackSubtitle: '始めましょう',
    dragDrop: 'ドラッグ＆ドロップ',
    dragDropSubtitle: 'ファイルをすばやくアップロード',
    switchStorage: '切り替え',
    switchStorageSubtitle: '上部メニューでクラウドとローカルを切り替え',
    installAgent: 'エージェントをインストール',
    installAgentSubtitle: 'ファイルを自動アップロード',
    playTrack: 'トラックを再生',
    playTrackSubtitle: '下部プレイヤーを開いてエフェクトを使用',
    community: '質問がありますか？{discord} と {telegram} のコミュニティに参加してください。'
  },
  create: {
    createProject: 'プロジェクトを作成',
    uploadTrack: 'トラックをアップロード',
    newProject: '新規プロジェクト',
    artist: 'アーティスト',
    name: '名前',
    create: '作成',
    loading: '読み込み中...',
    uploadCover: 'カバーをアップロード'
  },
  upload: {
    ariaLabel: 'トラックをアップロード',
    uploadTrack: 'トラックをアップロード',
    analyzing: '解析中...',
    fileAdded: 'ファイル "{name}" を追加しました',
    fileReadError: 'ファイル読み込みエラー。',
    errorWithMessage: 'エラー: {message}'
  },
  dragDrop: {
    dropToUpload: 'ドロップしてアップロード',
    deleteDrop: 'ここにドロップするとトラックを完全に削除します'
  },
  project: {
    upload: 'アップロード',
    noTracks: 'トラックなし',
    createdBy: '作成者',
    trackSummary: (ctx) => `${ctx.named('count')} トラック、${ctx.named('duration')}`,
    play: '再生',
    pause: '一時停止'
  },
  trackItem: {
    more: '詳細',
    copyPublicLink: '公開リンクをコピー',
    savedLocally: 'ローカルに保存済み',
    saveLocal: 'ローカルストレージに保存',
    saving: '保存中...',
    saveCloud: 'クラウドに保存',
    deleteTrack: 'トラックを削除',
    moveUp: '上へ移動',
    moveDown: '下へ移動',
    removeFromProject: '{project} から削除',
    moveToProject: 'プロジェクトへ移動',
    currentProject: '（現在）',
    confirmDelete: 'このトラックを削除しますか？',
    linkCopiedTitle: 'リンクをコピーしました',
    linkCopiedDescription: '公開リンクをクリップボードにコピーしました'
  },
  trackView: {
    created: '{time} に作成',
    tabs: {
      notes: 'メモ',
      metadata: 'メタデータ'
    },
    notFound: 'トラックが見つからないか、利用できません',
    untitled: '無題'
  },
  notes: {
    placeholder: 'このトラックについてメモを追加...',
    saving: '保存中...',
    saveError: 'メモを保存できませんでした。もう一度お試しください。'
  },
  metadata: {
    trackOrder: 'トラック順',
    artist: 'アーティスト',
    name: '名前',
    key: 'キー',
    mode: 'モード',
    deleteTrack: 'トラックを削除',
    saveError: 'メタデータを保存できませんでした。もう一度お試しください。'
  },
  lufs: {
    momentary: 'モーメンタリー LUFS',
    shortTerm: 'ショートターム LUFS',
    integrated: 'インテグレーテッド LUFS'
  },
  effects: {
    pitchshift: 'ピッチシフト',
    speed: '速度',
    balance: 'バランス',
    volume: '音量',
    reverberation: 'リバーブ',
    distortion: 'ディストーション',
    bitcrush: 'ビットクラッシュ',
    saveCurrentEffectsAs: '現在のエフェクトを保存',
    presetName: '名前',
    add: '追加',
    availablePresets: '利用可能なプリセット',
    tune: 'チューン',
    eq: 'EQ',
    fx: 'FX',
    presets: 'プリセット',
    center: '中央',
    left: '左',
    right: '右'
  },
  exportPanel: {
    applyEffects: '現在のエフェクトを適用',
    applyEffectsSubtitle: '現在のエフェクトを適用してトラックを書き出し',
    exportWav: 'WAV として書き出し',
    exportMp3: 'MP3 として書き出し',
    exporting: '書き出し中...',
    exportAsNewTrack: '新しいトラックとして書き出し',
    creatingTrack: 'トラックを作成中...',
    downloadOriginal: 'オリジナルをダウンロード',
    originalUnavailable: 'オリジナルファイルは利用できません。',
    downloadOriginalFailed: 'オリジナルファイルをダウンロードできませんでした。',
    exportAudioFailed: 'トラック音声を書き出せませんでした。',
    waveformFailed: '波形を生成できませんでした。',
    createTrackFailed: '書き出したトラックを作成できませんでした。',
    createTrackAlert: '書き出したトラックを作成できませんでした: {message}',
    exportedSuffix: '（書き出し）',
    copySuffix: '（コピー）'
  },
  publicLink: {
    copy: 'コピー',
    open: '開く',
    linkCopiedTitle: 'リンクをコピーしました',
    linkCopiedDescription: '公開リンクをクリップボードにコピーしました'
  },
  settings: {
    tabs: {
      settings: '設定',
      account: 'アカウント',
      links: 'リンク',
      agents: 'エージェント'
    },
    display: '表示',
    language: '言語',
    showBpm: 'トラック表示に BPM を表示',
    showBpmSubtitle: 'トラックリストで各トラックの BPM を表示',
    showLufs: 'トラック表示に LUFS を表示',
    showLufsSubtitle: 'トラックリストで各トラックのラウドネス単位を表示',
    showKey: 'トラック表示にキーを表示',
    showKeySubtitle: 'トラックリストで各トラックのキーとモードを表示',
    playback: '再生',
    liveLoudness: 'ライブラウドネスメーター',
    liveLoudnessSubtitle: 'プレイヤー画面にライブラウドネスメーターを表示',
    persistEffects: 'すべてのトラックでエフェクトを保持',
    persistEffectsSubtitle: 'トラックを切り替えても適用済みエフェクトを保持',
    keyboardShortcuts: 'キーボードショートカット',
    search: '検索',
    pressShortcut: '使用したいキーの組み合わせを押してください',
    storage: 'ストレージ',
    resetPresetsInfo: 'このブラウザに保存されたすべてのプリセットをリセット',
    resetPresets: 'プリセットをリセット',
    resetAllWarning: '警告！下のボタンはローカルストレージ内のすべてのデータを削除します。',
    resetAllData: 'ローカルストレージをリセットし、すべてのトラックとプロジェクトを削除',
    loadingAccount: 'アカウントを読み込み中...',
    loadingLinks: 'リンクを読み込み中...',
    loadingAgents: 'エージェントを読み込み中...',
    authPrompt: 'このセクションを使うにはログインまたは登録してください。',
    loginRegister: 'ログインまたは登録',
    pageTitle: {
      settings: '設定',
      account: 'アカウント設定',
      links: '公開リンク',
      agents: 'エージェント'
    },
    presetsCleared: 'プリセットストレージをクリアしました',
    localDataDeleted: 'すべてのローカルデータを削除しました',
    linkCopied: 'リンクをコピーしました',
    linkCopyFailed: 'リンクをコピーできませんでした'
  },
  account: {
    hello: 'こんにちは、{name}。',
    subscriptionStatus: '現在のサブスクリプションは {status} です',
    noSubscription: '有効なサブスクリプションはありません。',
    manageSubscription: 'サブスクリプションと支払い方法を管理',
    subscribeCloud: 'クラウドを使うために購読',
    changeUsername: 'ユーザー名を変更',
    changePassword: 'パスワードを変更',
    saveUsername: 'ユーザー名を保存',
    savePassword: 'パスワードを保存',
    newPassword: '新しいパスワード',
    confirmPassword: 'パスワード確認',
    usernamePlaceholder: 'ユーザー名',
    storageUsage: 'ストレージ使用量',
    baseStorage: '基本ストレージ',
    subscriptionStorage: 'サブスクリプションストレージ',
    used: '使用済み',
    available: '利用可能',
    deletedFilesNotice: '最近削除したファイルは、しばらくこれらのメトリクスに含まれる場合があります。数時間以内に更新されます。',
    accountId: 'アカウント id',
    currentPeriodEnds: (ctx) => `現在の支払い期間はあと ${ctx.named('count')} ${ctx.named('label')} で終了します`,
    accessEnds: (ctx) => `サブスクリプションアクセスはあと ${ctx.named('count')} ${ctx.named('label')} で終了します`,
    lastPaymentEnded: (ctx) => `前回の支払い期間は ${ctx.named('date')} に終了しました`,
    previousBillingDate: '前回の請求日',
    billingPortalError: '請求ポータルエラー',
    billingPortalFailed: '請求ポータルを開けませんでした。',
    loginRequiredUpdate: 'プロフィールを更新するにはログインが必要です。',
    usernameEmpty: 'ユーザー名は空にできません。',
    usernameUnchanged: 'ユーザー名は変更されていません。',
    usernameUpdated: 'ユーザー名を更新しました',
    usernameUpdateFailed: 'ユーザー名を更新できませんでした。もう一度お試しください。',
    passwordEmpty: 'パスワードは空にできません。',
    passwordsMismatch: 'パスワードが一致しません。',
    passwordUpdated: 'パスワードを更新しました',
    passwordUpdateFailed: 'パスワードを更新できませんでした。もう一度お試しください。'
  },
  links: {
    title: '公開リンク',
    description: '公開リンクはここに一覧表示されます。アクセスできる人はプロジェクトやトラックを聴けます。',
    cloudOnly: '公開リンクはクラウドモードでのみ利用できます。クラウドストレージに切り替えると、公開リンクを作成・管理できます。',
    noLinks: '利用可能な公開リンクはありません',
    createFirst: '最初の公開リンクを作成して共有を始めましょう。',
    confirmDelete: 'このリンクを削除しますか？',
    notFoundTitle: 'リンクが見つからないか期限切れです',
    notFoundDescription: 'アクセスしようとしているリンクは無効または期限切れです。',
    unknownUser: '不明'
  },
  agents: {
    authorizeTitle: 'エージェントを認証',
    authorizeDescription: 'このエージェントがあなたのアカウントに接続することを許可します。',
    loginToAuthorize: 'このエージェントを認証するにはログインしてください。',
    wantsConnect: 'このエージェントは音声ファイルを自動アップロードするため、あなたのアカウントに接続しようとしています。',
    permissionUpload: 'トラックをアップロード',
    permissionMetadata: 'トラックメタデータを作成',
    authorize: '認証',
    cancel: 'キャンセル',
    authorizedTitle: 'エージェントを認証しました',
    authorizedDescription: 'このウィンドウを閉じてエージェントアプリに戻れます。',
    desktopTitle: 'デスクトップエージェント',
    installDescription: 'PC または Mac に demoparty エージェントをインストールすると、新しく書き出したトラックを自動アップロードできます。',
    warningLabel: '警告: ',
    alphaWarning: 'エージェントは alpha 版で、不安定な場合があります。',
    downloadMacApple: 'Apple Silicon Mac 用をダウンロード',
    downloadMacIntel: 'Intel Mac 用をダウンロード',
    downloadWindows: 'Windows x64 用をダウンロード',
    signingNotice: 'これらのビルドはプロジェクトが開発中のためデジタル署名されていません。起動時のセキュリティ警告は想定されています。署名済みビルドは後日提供されます。',
    activeTitle: 'アクティブなエージェント',
    connectedDescription: 'あなたのアカウントに接続されているエージェント。',
    loginToManage: 'エージェントを管理するにはログインしてください。',
    noAgents: '接続済みエージェントはまだありません。',
    lastUsed: '最終使用',
    revoke: '取り消す',
    remove: '削除',
    confirmRemove: 'このエージェントを削除しますか？',
    authorizeFailed: 'エージェントを認証できませんでした。もう一度お試しください。'
  },
  login: {
    intro: 'クラウド機能とサブスクリプション特典を使うにはログインが必要です。それ以外の場合は、サービスをローカルで無料利用できます。',
    subscriptionBenefits: 'サブスクリプション特典',
    login: 'ログイン',
    register: '登録',
    forgot: 'パスワードを忘れました',
    email: 'e-mail',
    password: 'パスワード',
    repeatPassword: 'パスワードを再入力',
    or: 'または',
    google: 'Google でログイン',
    apple: 'Apple でログイン',
    resetPassword: 'パスワードをリセット',
    resetDescription: '新しいパスワードを設定できるサインインリンクを送信します。',
    sendResetLink: 'リセットリンクを送信',
    invalidToken: 'トークンが無効または期限切れです',
    enterEmail: 'e-mail を入力してください',
    resetSent: 'アカウントが存在する場合、サインインリンクを e-mail に送信しました。',
    resetFailed: 'リセットリンクを送信できませんでした。もう一度お試しください。'
  },
  googleCallback: {
    wait: 'ログイン中です。しばらくお待ちください...'
  },
  subscribe: {
    cloudRequiredTitle: 'クラウドストレージが必要です',
    cloudRequiredMessage: 'この機能はクラウドストレージと有効なサブスクリプションでのみ利用できます。',
    title: 'ローカルで開始。自動アップロードへアップグレード。',
    description: 'クラウドでは、デバイス間で同期された 1 つのライブラリを使えます。',
    localFree: 'アプリはローカルモードで無料利用できます。',
    cloudIncludes: 'クラウドに含まれるもの',
    featureLibrary: 'Web と iPhone 間で同期される 1 つのライブラリ',
    featureAgent: '新しい書き出し用のデスクトップエージェント自動アップロード',
    featureStorage: 'トラック用 100 GB クラウドストレージ',
    featureLinks: 'トラックとプロジェクト用の永続的な公開リンク',
    featureTools: 'すべてのローカル解析、エフェクト、書き出しツールを含む',
    monthly: '月額',
    monthlyDescription: 'クラウド同期、いつでもキャンセル可能',
    yearly: '年額',
    yearlyDescription: 'クラウド同期に最もお得',
    saveTen: '10% お得',
    perMonth: '/月',
    billedMonthly: '月ごとに請求',
    billedYearly: '年額 $53.89',
    openingCheckout: 'チェックアウトを開いています...',
    subscribePlan: '{plan} を購読',
    registerSubscribe: '登録して購読',
    securePayment: 'Polar による安全な支払い。アカウント設定からいつでもキャンセルできます。',
    customPlan: 'カスタムプランや質問がありますか？お問い合わせ先:',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
    refund: '返金ポリシー',
    checkoutFailed: 'チェックアウトを作成できませんでした。もう一度お試しください。'
  },
  thanks: {
    title: 'ご購読ありがとうございます！',
    description: 'クラウドストレージを利用できるようになりました。サブスクリプション管理はアカウントページで確認してください。',
    startWorking: '作業を開始',
    communities: 'コミュニティに参加',
    support: '問題がある場合は {email} または上のコミュニティリンクからお問い合わせください。'
  },
  help: {
    title: 'ヘルプ',
    intro: 'demoparty は未完成の音楽や進行中プロジェクトのためのワークスペースです。デモの保存、エフェクト適用、タグ編集、技術メタデータの追跡ができます。ローカル利用は完全に無料です。',
    uploadTitle: 'アップロード',
    uploadText: 'メインページの Add ボタンをクリックするとトラックを追加できます。アップロード中に、システムがキー、BPM、LUFS を自動検出します。アップロード完了後、確認通知が届きます。',
    storageTitle: 'ストレージ',
    storageText: 'demoparty にはローカルとクラウドの 2 つのストレージオプションがあります。',
    localStorageText: 'ローカルストレージはすべてのデータをあなたのデバイスのみに保存します。トラックとプロジェクトはアップロードしたブラウザでのみ利用できます。保存には IndexedDB を使用します。登録は不要で、データは送信されません。',
    cloudStorageText: 'クラウドストレージは demoparty サーバーにデータを保存します。どこからでもいつでもトラックにアクセスできます。登録と有効なサブスクリプションが必要です。',
    agentsTitle: 'エージェント',
    agentsText: 'クラウドストレージを使う場合、デスクトップエージェントをインストールできます。エージェントは新しく書き出されたトラックをクラウドへ自動アップロードします。',
    publicLinksTitle: '公開リンク',
    publicLinksText: 'クラウドユーザーはトラックやプロジェクトへの公開リンクを作成できます。プロジェクトページでリンクボタンをクリックしてください。トラックでは、トラックのドロップダウンメニューにある同じアイコンを使います。生成されたリンクはすべて設定から管理できます。',
    exportTitle: '書き出し',
    exportText: 'トラックは適用済みエフェクト込みで書き出せます。トラックページを開き、書き出しを選択します。オリジナルファイルをダウンロードするか、MP3 または WAV として書き出せます。',
    supportTitle: 'サポート',
    supportText: "demoparty クラウドサブスクリプションに関する問題は support{'@'}demoparty.app までお問い合わせください。",
    attributionsTitle: 'クレジット',
    attributionsText: '以下のライブラリがこのプロジェクトを可能にしました。各開発者に感謝します。'
  },
  cover: {
    upload: 'カバーをアップロード',
    change: 'カバーを変更',
    delete: 'カバーを削除',
    loading: '読み込み中...',
    selectImage: '画像ファイルを選択してください',
    uploadError: 'カバー画像のアップロードエラー'
  }
}
